import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';
// import buildExportQuery from './queryies/_export_all';
import { saveAs } from 'file-saver';
import moment from 'moment';

interface DeliveryDatesManagerState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;
    loaded_year: boolean;
    loading_year: boolean;
    fatalError_year: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    documents_by_dates: any[];
    holydays: any;
    year: any;
    delivery_zone: any;
    delivery_zones: any[];
    months: any[];
    days_data: any[];
    col_days: any[];
    prev_query: any;
    delivery_point: any;
    delivery_points: any[];
}

const state: DeliveryDatesManagerState = {
    loading: false,
    loaded: false,
    fatalError: false,
    loading_year: false,
    loaded_year: false,
    fatalError_year: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    documents_by_dates: [],
    holydays: {
        "1": {number: 1, days: [], ids: []},
        "2": {number: 2, days: [], ids: []},
        "3": {number: 3, days: [], ids: []},
        "4": {number: 4, days: [], ids: []},
        "5": {number: 5, days: [], ids: []},
        "6": {number: 6, days: [], ids: []},
        "7": {number: 7, days: [], ids: []},
        "8": {number: 8, days: [], ids: []},
        "9": {number: 9, days: [], ids: []},
        "10": {number: 10, days: [], ids: []},
        "11": {number: 11, days: [], ids: []},
        "12": {number: 12, days: [], ids: []},
    },
    year: null,
    delivery_zone: null,
    delivery_zones: [],
    months: [
        {number: 1},
        {number: 2},
        {number: 3},
        {number: 4},
        {number: 5},
        {number: 6},
        {number: 7},
        {number: 8},
        {number: 9},
        {number: 10},
        {number: 11},
        {number: 12},
    ],
    days_data: [],
    col_days: [],
    prev_query: {},
    delivery_point: null,
    delivery_points: [],
};

export const ITEMS_LIST = 'GET_CLIENT_LIST';
export const DELIVERY_ZONES = 'DELIVERY_ZONES';

function daysBetween(from: any, to: any) {
  const fromDate = moment(new Date(from)).startOf('day');
  const toDate = moment(new Date(to)).endOf('day');

  const span = moment.duration(toDate.diff(fromDate)).asDays();
  const days = [];
  for (let i = 0; i <= span; i++) {
    days.push(moment(fromDate).add(i, 'day').startOf('day'));
  }
  return days;
}

const _week_mapper: any = {
    1: 'пн',
    2: 'вт',
    3: 'ср',
    4: 'чт',
    5: 'пт',
    6: 'сб',
    7: 'вс',
}

export const actions: ActionTree<DeliveryDatesManagerState, RootState> = {

    loadDataByDates({ commit, getters, dispatch }, query) {
       const vm = (this as any)._vm;
        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            state.documents_by_dates = []
            state.col_days = []
            if (!query) {
                query = state.prev_query
            }
            state.prev_query = query;
            const days = daysBetween(query.from, query.to).map((day: any) => {
                const week_day = (day.day() == 0 ? 7 : day.day());
                return {
                    day: day,
                    label: (day.format('DD.MM.YYYY') + ', ' + _week_mapper[week_day]),
                    week_day: week_day,
                    week_label: _week_mapper[week_day]
                }
            });
            vm.$db([
                vm.$q('HOLYDATS_LIST')
                .raw('documents.list')
                .action({
                    columns: {
                        id: 'ddh.id',
                        delivery_zone_id: 'ddh.delivery_zone_id',
                        date: 'ddh.date',
                    },
                    from: "s:delivery_date_holydays",
                    from_as: "ddh",
                    page_size: 1000000,
                    where: {
                        $and: [
                            {$gte: ['ddh.date', {$: moment(query.from).format('YYYY-MM-DD')}]},
                            {$lte: ['ddh.date', {$: moment(query.to).format('YYYY-MM-DD')}]},
                        ]
                    }
                }),

                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    columns: {
                        id: 'ddc.id',
                        delivery_zone_id: 'ddc.delivery_zone_id',
                        delivery_point_id: 'ddc.delivery_point_id',
                        date: 'ddc.date',
                        comment: 'ddc.comment'
                    },
                    from: "s:delivery_date_comments",
                    from_as: "ddc",
                    page_size: 1000000,
                    where: {
                        $and: [
                            {$gte: ['ddc.date', {$: moment(query.from).format()}]},
                            {$lte: ['ddc.date', {$: moment(query.to).format()}]},
                        ]
                    }
                })
            ]).then((response: ServerResult) => {
                const _comments = response.getOperation(ITEMS_LIST).getContent().documents.reduce((acc: any, item: any) => {
                    const key = [item.delivery_zone_id, item.delivery_point_id, moment(item.date).format('YYYY-MM-DD')].join(',')
                    acc[key] = item;
                    return acc
                }, {})
                const _holydays = response.getOperation('HOLYDATS_LIST').getContent().documents.reduce((acc: any, item: any) => {
                    const key = [item.delivery_zone_id, null, moment(item.date).format('YYYY-MM-DD')].join(',')
                    acc[key] = true;
                    return acc
                }, {})
                console.log(_comments)
                dispatch('loadData', {}).then(() => {
                    commit('SET_BY_DATES_LIST', {documents: state.documents.map((item: any) => {
                        if (item.zones) {
                            item.zones = item.zones.map((zone: any) => {
                                const _allows = zone.days.reduce((acc: any, item: any) => {
                                    acc[item.week_day] = item.is_allow
                                    return acc
                                }, {})
                                zone.dates = days.reduce((acc: any[], day: any) => {
                                    const key = [zone.id, null, day.day.format('YYYY-MM-DD')].join(',')
                                    const _comment = _comments[key] || {}
                                    const _holyday = _holydays[key] || false
                                    acc.push({
                                        day: day,
                                        label: day.label,
                                        is_allow: _allows[day.week_day] && !_holyday,
                                        icon: false,
                                        comment: _comment.comment,
                                        comment_id: _comment.id
                                    })
                                    return acc
                                }, []) 
                                zone.delivery_points = zone.delivery_points.map((point: any) => {
                                    const _allows = point.days.reduce((acc: any, item: any) => {
                                        acc[item.week_day] = item.is_allow
                                        return acc
                                    }, {})
                                    point.dates = days.reduce((acc: any[], day: any) => {
                                        const key = [zone.id, point.id, day.day.format('YYYY-MM-DD')].join(',')
                                        const key_zone = [zone.id, null, day.day.format('YYYY-MM-DD')].join(',')
                                        const _comment = _comments[key] || {comment: (_comments[key_zone] || {}).comment}
                                        const _holyday = _holydays[key_zone] || false
                                        acc.push({
                                            day: day,
                                            label: day.label,
                                            is_allow: _allows[day.week_day] && !_holyday,
                                            icon: false,
                                            comment: _comment.comment,
                                            comment_id: _comment.id
                                        })
                                        return acc
                                    }, []) 

                                    return point
                                })
                                return zone
                            });
                        }
                        return item;
                    }), days: days})
                    commit('LOADED_SUCCESS');
                })        
            })
        })
    },


    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                id: 'delivery_zone_groups.id',
                name: 'delivery_zone_groups.name',
                created_at: 'delivery_zone_groups.created_at',
                updated_at: 'delivery_zone_groups.updated_at',
                zones: 'grouped_delivery_zones.zones'
              };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["delivery_zone_groups.name", {"$": `%${query.name}%`}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    from: 's:delivery_zone_groups',
                    from_as: 'delivery_zone_groups',
                    joins: [
                        {
                            join: {
                              columns: {
                                delivery_zone_group_id: 'delivery_zones.delivery_zone_group_id',
                                zones: {
                                    $array_agg: {
                                      $obj: {
                                        id: 'delivery_zones.id',
                                        name: 'delivery_zones.name',
                                        days: 'delivery_date_schedule.days',
                                        delivery_points: 'delivery_points.delivery_points',
                                        office_schedules: 'office_schedules.office_schedules',
                                      }
                                    }
                                  },
                              },
                              from: 's:delivery_zones',
                              from_as: 'delivery_zones',
                              joins:[
                                {
                                    join: {
                                        columns: {
                                            delivery_zone_id: 'delivery_date_schedule.delivery_zone_id',
                                            days: {
                                                $array_agg: {
                                                  $obj: {
                                                    id: 'delivery_date_schedule.id',
                                                    week_day: 'delivery_date_schedule.week_day',
                                                    time: 'delivery_date_schedule.time',
                                                    is_allow: 'delivery_date_schedule.is_allow',
                                                  }
                                                }
                                            },
                                        },
                                        from: 's:delivery_date_schedule',
                                        from_as: 'delivery_date_schedule',
                                        groups: [
                                            'delivery_date_schedule.delivery_zone_id'
                                        ],
                                        where: {
                                            $null: ['delivery_date_schedule.delivery_point_id']
                                        }

                                    },
                                    as: 'delivery_date_schedule',
                                    type: 'left',
                                    on: {
                                        $eq: ['delivery_date_schedule.delivery_zone_id', 'delivery_zones.id']
                                    } 
                                },
                                {
                                    join: {
                                        columns: {
                                            delivery_zone_id: 'office_schedules.delivery_zone_id',
                                            office_schedules: {
                                                $array_agg: {
                                                  $obj: {
                                                    id: 'office_schedules.id',
                                                    date: 'office_schedules.date',
                                                  }
                                                }
                                            },
                                        },
                                        from: 's:office_schedules',
                                        from_as: 'office_schedules',
                                        groups: [
                                            'office_schedules.delivery_zone_id'
                                        ],                                    },
                                    as: 'office_schedules',
                                    type: 'left',
                                    on: {
                                        $eq: ['office_schedules.delivery_zone_id', 'delivery_zones.id']
                                    } 
                                },
                                {
                                    join: {
                                        columns: {
                                            delivery_zone_id: 'delivery_points_delivery_zones.delivery_zone_id',
                                            delivery_points: {
                                                $array_agg: {
                                                  $obj: {
                                                    id: 'delivery_points.id',
                                                    client_name: 'clients.name',
                                                    address: 'delivery_points.address',
                                                    days: 'delivery_date_schedule.days'
                                                  }
                                                }
                                            },
                                        },
                                        from: 's:delivery_points',
                                        from_as: 'delivery_points',
                                        joins:[
                                            {
                                                join: 's:delivery_points_delivery_zones',
                                                as: 'delivery_points_delivery_zones',
                                                on: {
                                                    $eq : ['delivery_points_delivery_zones.delivery_point_id', 'delivery_points.id']
                                                }
                                            },
                                            {
                                                join: 's:clients',
                                                as: 'clients',
                                                on: {
                                                    $and: [
                                                        {$eq : ['delivery_points.client_id', 'clients.id']},
                                                        {$null: ['clients.archived_at']},
                                                        {$not: [{$in: ['clients.type_id', {$: ['d:client_types:5', 'd:client_types:6', 'd:client_types:9']}]}]}
                                                    ]
                                                }
                                            },
                                            {
                                                join: {
                                                    columns: {
                                                        delivery_point_id: 'delivery_date_schedule.delivery_point_id',
                                                        days: {
                                                            $array_agg: {
                                                              $obj: {
                                                                id: 'delivery_date_schedule.id',
                                                                week_day: 'delivery_date_schedule.week_day',
                                                                time: 'delivery_date_schedule.time',
                                                                is_allow: 'delivery_date_schedule.is_allow',
                                                              }
                                                            }
                                                        },
                                                    },
                                                    from: 's:delivery_date_schedule',
                                                    from_as: 'delivery_date_schedule',
                                                    groups: [
                                                        'delivery_date_schedule.delivery_point_id'
                                                    ],
                                                },
                                                as: 'delivery_date_schedule',
                                                type: 'left',
                                                on: {
                                                    $eq: ['delivery_date_schedule.delivery_point_id', 'delivery_points.id']
                                                } 
                                            },
                                        ],
                                        where: {
                                            $null: ['delivery_points.archived_at']
                                        },
                                        groups: [
                                            'delivery_points_delivery_zones.delivery_zone_id'
                                        ],
                                    },
                                    as: 'delivery_points',
                                    type: 'left',
                                    on: {
                                        $eq: ['delivery_points.delivery_zone_id', 'delivery_zones.id']
                                    } 
                                }
                              ],
                              groups: [
                                'delivery_zones.delivery_zone_group_id'
                              ],
                            },
                            type: 'left',
                            as: 'grouped_delivery_zones',
                            on: { $eq: ['grouped_delivery_zones.delivery_zone_group_id', 'delivery_zone_groups.id'] }
                        }
                    ],
                    page_size: 100,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'name' ]] } : { $asc: [columns[query.sortField || 'name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    setValue({ state, commit}, {index, idx, day_idx, field, newValue}) {
        commit('SET_VALUE', {index, idx, day_idx, field, newValue});
    }, 

    setDeliveryPoints({ state, commit}, points) {
        commit('SET_DELIVERY_POINTS', points);
    }, 
    setPointValue({ state, commit}, {index, idx, point_idx, day_idx, field, newValue}) {
        commit('SET_POINT_VALUE', {index, idx, point_idx, day_idx, field, newValue});
    },

    setComment({state, commit, dispatch}, {comment, zone_id, point_id, day}) {
        const vm = (this as any)._vm;
        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            let saveQuery = null;
            const normalizedForm: any = {
                delivery_zone_id: zone_id,
                delivery_point_id: point_id,
                date: moment(day.day.day).format('YYYY-MM-DD HH:mm:ss'),
                comment: comment
            }
            const documentId = day.comment_id

            if (documentId) {
                saveQuery = vm.$q('DATA_SAVE')
                    .update(documentId, normalizedForm)
            } else {
                saveQuery = vm.$q('DATA_SAVE')
                    .create('s:delivery_date_comments', normalizedForm)
            }

            vm.$db([
                saveQuery
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('DATA_SAVE');

                if (operationResult.hasError()) {
                    console.log('error', operationResult.getContent());

                    commit('LOADED_SUCCESS');
                    reject();
                } else {
                    commit('UPDATE_COMMENT', {zone_id, point_id, day, comment})

                    commit('LOADED_SUCCESS');
                    resolve(operationResult.getContent());
                    dispatch('loadDataByDates', null)
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });

        })

        console.log(comment, zone_id, point_id, day)
    },

    setHolydays({ commit, dispatch }, {month, newValue, allZones}) {
        const vm = (this as any)._vm;
       
        return new Promise((resolve, reject) => {
            commit('START_LOADING_YEAR');
            const _deleted = state.holydays[month] ? state.holydays[month].days.map((item: any) => {
                return newValue.indexOf(item)
            }).map((item: any, idx: number) => {
                const id = state.holydays[month].ids[idx]
                if (id) {
                    return vm.$q('DELIVERY_DATE_HOLYDAY_SAVE-' + id)
                        .raw('documents.delete')
                        .action({id: id})
                }
            }).filter((item: any) => {return item}) : []


            const queres: any[] = [..._deleted];
            
            if (allZones) {
                state.holydays[month].days.map((day: any, idx: number) => {
                    state.delivery_zones.map((item: any) => {
                        queres.push(vm.$q('DELIVERY_DATE_HOLYDAY_SAVE-' + idx + '-' + month + '-' + item.id)
                            .create('s:delivery_date_holydays', {
                                date: moment(day).format('YYYY-MM-DD'),
                                delivery_zone_id: item.id,
                            }))
                    })
                })
            } else {
                state.holydays[month].days.map((day: any, idx: number) => {
                    if (newValue.indexOf(day) >= 0) {
                        const id = state.holydays[month].ids[idx]
                        if (state.delivery_point) {
                            queres.push(vm.$q('DELIVERY_DATE_HOLYDAY_SAVE-' + idx + '-' + month)
                            .create('s:delivery_date_holydays', {
                                date: moment(day).format('YYYY-MM-DD'),
                                delivery_zone_id: state.delivery_zone,
                                delivery_point_id: state.delivery_point,
                            }))
                        } else {
                             queres.push(vm.$q('DELIVERY_DATE_HOLYDAY_SAVE-' + idx + '-' + month)
                                .create('s:delivery_date_holydays', {
                                    date: moment(day).format('YYYY-MM-DD'),
                                    delivery_zone_id: state.delivery_zone,
                                }))
                            state.delivery_points.map((point: any, point_idx: number) => {
                                queres.push(vm.$q('DELIVERY_DATE_HOLYDAY_SAVE-' + idx + '-' + point_idx + '-' + month)
                                    .create('s:delivery_date_holydays', {
                                        date: moment(day).format('YYYY-MM-DD'),
                                        delivery_zone_id: state.delivery_zone,
                                        delivery_point_id: point.id,
                                    }))
                            })
                        }
                   }
                })
            }
            console.log(queres)


            vm.$db(queres).then((result: ServerResult) => {
                commit('LOADED_SUCCESS_YEAR');
                dispatch('setYear', {newValue: state.year, delivery_zone: state.delivery_zone, delivery_point: null, allZones})
                resolve(null);
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        }); 
    },

    setYear({ commit}, {newValue, delivery_zone, delivery_point, allZones}) {
        const vm = (this as any)._vm;
        state.delivery_point = delivery_point;
        
        return new Promise((resolve, reject) => {
            commit('SET_YEAR', {newValue, delivery_zone});
            console.log('setYear', {newValue, delivery_zone, delivery_point, allZones}) 
            if (!allZones && !delivery_zone) {
                commit('LOADED_CLEAR_YEAR')         
            } else {
                const start = moment(state.year + '-01-01').format('YYYY-MM-DD')
                const end = moment(state.year + '-12-31').format('YYYY-MM-DD')
                const filter: any[] = [];
                filter.push({ "$gte": ["delivery_date_holydays.date", {"$": start}] })
                filter.push({ "$lte": ["delivery_date_holydays.date", {"$": end}] })
                if (state.delivery_zone) {  
                    commit('START_LOADING_YEAR'); 
                    const columns: any = {
                        id: 'delivery_date_holydays.id',
                        date: 'delivery_date_holydays.date',
                        created_at: 'delivery_date_holydays.created_at',
                        updated_at: 'delivery_date_holydays.updated_at',
                      };
        
                    filter.push({ "$eq": ["delivery_date_holydays.delivery_zone_id", {"$": delivery_zone}] })
                    if (delivery_point) {
                        filter.push({ "$eq": ["delivery_date_holydays.delivery_point_id", {"$": delivery_point}] })
                    } else {
                        filter.push({ "$null": ["delivery_date_holydays.delivery_point_id"] })
                    }
       
                    vm.$db([
                        vm.$q('DAYS_LIST')
                        .raw('documents.list')
                        .action({
                            columns: {
                                delivery_zone_id: `delivery_date_schedule.delivery_zone_id`,
                                days: {
                                    $array_agg: {
                                      $obj: {
                                        id: 'delivery_date_schedule.id',
                                        week_day: 'delivery_date_schedule.week_day',
                                        time: 'delivery_date_schedule.time',
                                        is_allow: 'delivery_date_schedule.is_allow',
                                        delivery_point_id: `delivery_date_schedule.delivery_point_id`,
                                      }
                                    }
                                },
                            },
                            from: 's:delivery_date_schedule',
                            from_as: 'delivery_date_schedule',
                            groups: [
                                `delivery_date_schedule.delivery_zone_id`
                            ],
                            where: {
                                $or: [
                                    {$and: [
                                        {$eq: [`delivery_date_schedule.delivery_zone_id`, {$: delivery_zone}]},
                                        {$null: [`delivery_date_schedule.delivery_point_id`]}
                                    ]},
                                    ...(
                                        delivery_point ? 
                                        [{$eq: [`delivery_date_schedule.delivery_point_id`, {$: delivery_point}]}] : 
                                        []
                                    )
                                ]
                            }
                        }),
                        vm.$q(ITEMS_LIST)
                        .raw('documents.list')
                        .action({
                            "columns": columns,
                            from: 's:delivery_date_holydays',
                            from_as: 'delivery_date_holydays',
                            page_size: 1000,
                            ...(
                                filter.length > 1 ?
                                {
                                    "where": {
                                        "$and": filter
                                    }
                                } : {
                                    "where": filter[0]
                                }
                            )
        
                        })
                    ]).then(((result: ServerResult) => {
                        const _holydays = result.getOperation(ITEMS_LIST).getContent().documents.reduce((acc: any, item: any) => {
                            const date = moment(item.date)
                            if (!acc[date.format('M')]) {
                                acc[date.format('M')] = {
                                    days: [],
                                    ids: []
                                }
                            }
                            acc[date.format('M')].days.push(date.toDate())
                            acc[date.format('M')].ids.push(item.id)
                            return acc
                        }, Object.keys(state.holydays).reduce((acc: any, key: any) => {
                            const item = state.holydays[key]; 
                            item.days.splice(0, item.days.length)
                            item.ids.splice(0, item.ids.length)
                            acc[key] = item
                            return acc
                        }, {}))
        
                        // Object.keys(_holydays).map((key: any) => {
                        // })
                        commit('SET_HOLYDAYS_ALL', {newValue: _holydays});
                        commit('SET_DAYS', {documents: result.getOperation('DAYS_LIST').getContent().documents, delivery_point});
                        commit('LOADED_SUCCESS_YEAR');
        
                        resolve(null);
                    }));
                } else if (allZones) {
                    commit('START_LOADING_YEAR');
                    vm.$db([
                        vm.$q(DELIVERY_ZONES)
                        .raw('documents.list')
                        .action({
                            columns: {
                                id: 'delivery_zones.id'
                            },
                            from: 's:delivery_zones',
                            from_as: 'delivery_zones',
                            page_size: 1000,
                        }),
                        vm.$q(ITEMS_LIST)
                        .raw('documents.list')
                        .action({
                            columns: {
                                date: 'delivery_date_holydays.date',
                                ids: {$array_agg: 'delivery_date_holydays.id'},
                            },
                            from: 's:delivery_date_holydays',
                            from_as: 'delivery_date_holydays',
                            joins: [
                                {
                                    join: 's:delivery_zones',
                                    // type: 'left',
                                    as: 'delivery_zones',
                                    on: {
                                        $eq: ['delivery_date_holydays.delivery_zone_id', 'delivery_zones.id']
                                    }
                                }
                            ],
                            page_size: 1000,
                            groups: [
                                'delivery_date_holydays.date'
                            ],
                            ...(
                                filter.length > 1 ?
                                {
                                    "where": {
                                        "$and": filter
                                    }
                                } : {
                                    "where": filter[0]
                                }
                            )
        
                        })
                    ]).then(((result: ServerResult) => {
                        state.delivery_zones = result.getOperation(DELIVERY_ZONES).getContent().documents;
    
                        const _holydays = result.getOperation(ITEMS_LIST).getContent().documents.reduce((acc: any, item: any) => {
                            if (item.ids.length >= state.delivery_zones.length) {
                                const date = moment(item.date)
                                if (!acc[date.format('M')]) {
                                    acc[date.format('M')] = {
                                        days: [],
                                        ids: []
                                    }
                                }
                                acc[date.format('M')].days.push(date.toDate())
                                acc[date.format('M')].ids.push(...item.ids)
                            }
                            return acc
                        }, Object.keys(state.holydays).reduce((acc: any, key: any) => {
                            const item = state.holydays[key]; 
                            item.days.splice(0, item.days.length)
                            item.ids.splice(0, item.ids.length)
                            acc[key] = item
                            return acc
                        }, {}))
                        console.log('_holydays 2', _holydays)
        
                        commit('SET_HOLYDAYS_ALL', {newValue: _holydays});
                        commit('SET_DAYS', {documents: [{'days': []}], delivery_point});
                        
                        commit('LOADED_SUCCESS_YEAR');
        
                        resolve(null);
                    }));
                } else {
                    resolve(null);
                }
            }
        })
    },

    cancelSave({ state, commit}, {index, idx}) {
        commit('CANCEL_SAVE', {index, idx});
    },

    saveZone({ state, commit }, {index, idx}) {
        const vm = (this as any)._vm;
        const zone: any = state.documents[index].zones[idx];

        return new Promise((resolve, reject) => {
            const queres: any[] = Object.keys(zone.days).reduce((acc: any[], key: any, idx: number) => {
                const day: any = zone.days[key];
                let saveQuery: any;
                if (day.id) {
                    saveQuery = vm.$q('DELIVERY_DATE_DATA_SAVE-' + idx)
                        .update(day.id, {
                            time: day.new_time ? moment(day.new_time).format('HH:mm:ss') : null,
                            is_allow: day.is_allow
                        })
                } else {
                    saveQuery = vm.$q('DELIVERY_DATE_DATA_SAVE-' + idx)
                        .create('s:delivery_date_schedule', {
                            delivery_zone_id: zone.id,
                            time: day.new_time ? moment(day.new_time).format('HH:mm:ss') : null,
                            week_day: day.week_day,
                            is_allow: day.is_allow
                        })
                }
                if (saveQuery) {
                    acc.push(saveQuery)
                }
                return acc
            }, [])

            vm.$db(queres).then((result: ServerResult) => {
                commit('SAVE_ZONE', {index, idx});
                resolve(null);
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    cancelPointSave({ state, commit}, {index, idx, point_idx}) {
        commit('CANCEL_POINT_SAVE', {index, idx, point_idx});
    },

    savePoint({ state, commit }, {index, idx, point_idx}) {
        const vm = (this as any)._vm;
        const zone: any = state.documents[index].zones[idx];
        const point: any = zone.delivery_points[point_idx];

        return new Promise((resolve, reject) => {
            const queres: any[] = Object.keys(point.days).reduce((acc: any[], key: any, idx: number) => {
                const day: any = point.days[key];
                let saveQuery: any;
                if (day.id) {
                    saveQuery = vm.$q('DELIVERY_DATE_DATA_SAVE-' + idx)
                        .update(day.id, {
                            time: day.new_time ? moment(day.new_time).format('HH:mm:ss') : null,
                            is_allow: day.is_allow
                        })
                } else {
                    saveQuery = vm.$q('DELIVERY_DATE_DATA_SAVE-' + idx)
                        .create('s:delivery_date_schedule', {
                            delivery_zone_id: zone.id,
                            delivery_point_id: point.id,
                            time: day.new_time ? moment(day.new_time).format('HH:mm:ss') : null,
                            week_day: day.week_day,
                            is_allow: day.is_allow
                        })
                }
                if (saveQuery) {
                    acc.push(saveQuery)
                }
                return acc
            }, [])

            vm.$db(queres).then((result: ServerResult) => {
                commit('SAVE_POINT', {index, idx, point_idx});
                resolve(null);
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    removeSchedule({state, commit}, row) {
        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            const vm = (this as any)._vm;

            const saveQuery = vm.$q('SAVE')
                .raw('documents.delete')
                .action({id: row.id})
            vm.$db([
                saveQuery
            ]).then(((result: ServerResult) => {
                console.log(result)
                commit('LOADED_SUCCESS');
                resolve(null);
            }));
        })

    }
};

export const mutations: MutationTree<DeliveryDatesManagerState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },
    START_LOADING_YEAR: (state) => {
        state.loaded_year = false;
        state.loading_year = true;
        state.fatalError_year = false;
    },
    LOADED_SUCCESS_YEAR: (state) => {
        state.loaded_year = true;
        state.loading_year = false;
        state.fatalError_year = false;
    },
    LOADED_CLEAR_YEAR: (state) => {
        state.loaded_year = false;
        state.loading_year = false;
        state.fatalError_year = false;
    },
    LOADED_ERROR_YEAR: (state) => {
        state.loaded_year = true;
        state.loading_year = false;
        state.fatalError_year = true;
    },

    SET_VALUE(state, {index, idx, day_idx, field, newValue}) { 
        state.documents[index].zones[idx].days[day_idx][field] = newValue
    },

    SET_POINT_VALUE(state, {index, idx, point_idx, day_idx, field, newValue}) { 
        state.documents[index].zones[idx].delivery_points[point_idx].days[day_idx][field] = newValue
    },

    SET_HOLYDAYS_ALL(state, {newValue}) { 
        state.holydays = newValue
    },
    SET_DELIVERY_POINTS(state, points) { 
        state.delivery_points = points
    },

    SET_HOLYDAYS(state, {month, newValue}) { 
        state.holydays[month].days = newValue
    },
    SET_DAYS(state, {documents, delivery_point}) {
        const week_days: any = documents[0].days.filter((item: any) => {
          return item.delivery_point_id == delivery_point
        });
        state.days_data = (week_days.length ? week_days : documents[0].days).map((item: any) => {
            console.log('item => ', item)
            return !item.is_allow ? (item.week_day < 7 ? item.week_day : 0) : null;
        }).filter((item: any) => {
            return item != null;
        })
    },

    SET_BY_DATES_LIST(state, {documents, days}) {
        state.documents_by_dates = documents
        state.col_days = days
    },
    UPDATE_COMMENT(state, {zone_id, point_id, day, comment}) {
        state.documents_by_dates.map((item: any) => {
            if (item.zones) {
                item.zones.map((zone: any) => {
                    if (zone.id == zone_id) {
                        if (!point_id) {
                            zone.dates.map((date: any) => {
                                if (day.label == date.day.label) {
                                    date.day = day
                                }
                            })
                        }
                    }
                })
            }
        })
    },

    SET_YEAR(state, {newValue, delivery_zone}) { 
        state.delivery_zone = delivery_zone;
        state.year = newValue ? newValue: moment().year(),
        state.months = state.months.map((item: any) => {
            const start = moment(state.year + '-' + item.number + '-01')
            return {
                start: start.toDate(), 
                end: start.add(1, 'month').subtract(1, 'days').toDate(), 
                number: item.number
            }
        })
    },

    CANCEL_SAVE(state, {index, idx}) { 
        state.documents[index].zones[idx].edited = false;
        state.documents[index].zones[idx].days.map((day: any) => {
            day.new_time = day.time
        })
    },

    CANCEL_POINT_SAVE(state, {index, idx, point_idx}) { 
        state.documents[index].zones[idx].delivery_points[point_idx].edited = false;
        state.documents[index].zones[idx].delivery_points[point_idx].days.map((day: any) => {
            day.new_time = day.time
        })
    },

    SAVE_ZONE(state, {index, idx}) { 
        state.documents[index].zones[idx].edited = false;
        state.documents[index].zones[idx].days.map((day: any) => {
            day.time = day.new_time
        })
    },

    SAVE_POINT(state, {index, idx, point_idx}) { 
        state.documents[index].zones[idx].delivery_points[point_idx].edited = false;
        state.documents[index].zones[idx].delivery_points[point_idx].days.map((day: any) => {
            day.time = day.new_time
        })
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents.map((item: any) => {
            item.edited = false;
            if (item.zones) {
                item.zones = item.zones.map((zone: any) => {
                    const days: any = {
                        1: {time: null, week_day: 1},
                        2: {time: null, week_day: 2},
                        3: {time: null, week_day: 3},
                        4: {time: null, week_day: 4},
                        5: {time: null, week_day: 5},
                        6: {time: null, week_day: 6},
                        7: {time: null, week_day: 7},
                    }
                    zone.edited = false;
                    zone.folded = true;
                    
                    zone.days = Object.values(Object.assign(days, zone.days ? zone.days.reduce((acc: any, day: any) => {
                        if (day.time) {
                            day.time = moment(day.time, 'HH:mm:ss').toDate()
                            day.new_time = moment(day.time, 'HH:mm:ss').toDate()
                        }
                        acc[day.week_day] = day
                        return acc
                    }, {}) : {}))
                    zone.delivery_points = zone.delivery_points ? zone.delivery_points.map((item: any) => {
                        const days: any = {
                            1: Object.assign({}, zone.days[0], {id: null}),
                            2: Object.assign({}, zone.days[1], {id: null}),
                            3: Object.assign({}, zone.days[2], {id: null}),
                            4: Object.assign({}, zone.days[3], {id: null}),
                            5: Object.assign({}, zone.days[4], {id: null}),
                            6: Object.assign({}, zone.days[5], {id: null}),
                            7: Object.assign({}, zone.days[6], {id: null}),
                        }
                        item.edited = false;
                        item.folded = true;
                        item.days = Object.values(Object.assign(days, item.days ? item.days.reduce((acc: any, day: any) => {
                            if (day.time) {
                                day.time = moment(day.time, 'HH:mm:ss').toDate()
                                day.new_time = moment(day.time, 'HH:mm:ss').toDate()
                            }
                            acc[day.week_day] = Object.assign({}, day)
                            return acc
                        }, {}) : {}))
                        return item
                    }) : [];
                    return zone
                })
            }
            return item;
        });

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {
};

export const STORE_KEY = '$_delivery_dates_manager';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
